import React from 'react';
import { Text, TextInput, StyleSheet, View } from 'react-native';
import { MainColors } from '../../constants/Colors';
import FontSizes from '../../constants/FontSizes';
import LinkStyleButton from '../Buttons/LinkStyleButton';
import MainButton from '../Buttons/MainButton';
import { Ionicons } from '@expo/vector-icons';
import ModalWrapper from './ModalWrapper';

const DeleteModal = (props) => {
    return (
        <ModalWrapper visible={props.visible} onModalBackgroundPressed={props.onModalBackgroundPressed}>
            <Ionicons style={styles.warningIcon} name="ios-warning" size={30} color={MainColors.darkGray} />
            <Text style={styles.message}>Are you sure you want to delete </Text>
            <Text style={styles.itemToDelete}>{props.itemToDelete}?</Text>
            <View style={styles.textInputContainer}>
                <TextInput
                    style={styles.deleteTextInput}
                    selectionColor={MainColors.mediumGray}
                    placeholderTextColor={MainColors.mediumGray}
                    placeholder='Type "DELETE" to confirm'
                    value={props.deleteInputValue}
                    onChangeText={props.onChangeDeleteInputText}
                    accessibilityLabel='Type "DELETE" to confirm'
                    accessibilityHint='Type the characters "DELETE" to confirm'
                />
            </View>

            <MainButton
                disabled={props.deleteButtonDisabled}
                style={styles.deleteButton}
                style={props.deleteButtonDisabled ? styles.disabledDeleteButton : styles.deleteButton}
                onPress={props.onModalDeletePress}
                accessibilityLabel='Delete'
                accessibilityHint='Press this button to delete this item'
                text="Delete"
            />
            <LinkStyleButton
                style={styles.cancelButton}
                buttonText='Nevermind. Abort! Abort!'
                accessibilityLabel='Cancel'
                accessibilityHint='Press this button to back out of this deletion'
                onPress={props.onCancelPressed}
            />
        </ModalWrapper>
    )
}

const styles = StyleSheet.create({
    modalBackground: {
        flex: 1,
        justifyContent: "center",
        backgroundColor: MainColors.dimmedBackground
    },
    modalContainer: {
        marginHorizontal: 30,
        paddingVertical: 20,
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: 8
    },
    warningIcon: {
        marginBottom: 15,
        alignSelf: 'center'
    },
    textInputContainer: {
        paddingHorizontal: 30
    },
    message: {
        textAlign: 'center',
        fontSize: FontSizes.large,
        marginBottom: 5,
        color: MainColors.darkGray
    },
    itemToDelete: {
        textAlign: 'center',
        fontSize: FontSizes.medium,
        fontWeight: '700',
        color: MainColors.darkGray,
        letterSpacing: 0.5,
        marginHorizontal: 20
    },
    deleteTextInput: {
        textAlign: 'center',
        height: 40,
        margin: 12,
        borderBottomWidth: 2,
        borderBottomColor: MainColors.lightGray,
        fontSize: FontSizes.medium
    },
    deleteButton: {
        backgroundColor: MainColors.danger,
        borderRadius: 5,
        height: 40,
        minWidth: 120,
        maxWidth: 220
    },
    disabledDeleteButton: {
        backgroundColor: MainColors.lightGray,
        borderRadius: 5,
        height: 40,
        minWidth: 120,
        maxWidth: 220
    },
    cancelButton: {
        marginTop: 30,
        fontSize: FontSizes.medium
    }
});

export default DeleteModal;